exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".field-log{border-bottom:1px solid #d6d6d6;margin-bottom:1rem}.field-log:last-child{border-bottom:none}.attachments{padding-bottom:15px;border-bottom:1px solid #dcdcdc;margin-top:15px}.attachments:last-child{border-bottom:none}", "", {"version":3,"sources":["/./src/app/components/fieldLogModal/src/app/components/fieldLogModal/fieldlogmodal.scss"],"names":[],"mappings":"AAAA,WACE,gCAAgC,AAChC,kBAAmB,CAIpB,AAND,sBAII,kBAAmB,CACpB,AAGH,aACE,oBAAoB,AACpB,gCAAkC,AAClC,eAAgB,CAIjB,AAPD,wBAKI,kBAAmB,CACpB","file":"fieldlogmodal.scss","sourcesContent":[".field-log {\n  border-bottom: 1px solid #d6d6d6;\n  margin-bottom: 1rem;\n  &:last-child {\n    border-bottom: none;\n  }\n}\n\n.attachments {\n  padding-bottom: 15px;\n  border-bottom: 1px solid gainsboro;\n  margin-top: 15px;\n  &:last-child {\n    border-bottom: none;\n  }\n}\n"],"sourceRoot":"webpack://"}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?root=/opt/buildhome/repo/src&sourceMap!./node_modules/postcss-loader!./node_modules/sass-loader?outputStyle=expanded&sourceMap=true&sourceMapContents=true!./src/app/components/fieldLogModal/fieldlogmodal.scss
// module id = 918
// module chunks = 0